import { apiClient } from ".";
import { useMutation } from "@tanstack/react-query";
import { captureException } from "@sentry/react";

export const startSignUp = async ({
  personalNumber,
  transactionId,
}: {
  personalNumber: string;
  transactionId: string;
}) => {
  const response = await apiClient({
    url: `/auth/sign-up`,
    method: "POST",
    data: {
      username: personalNumber,
      transactionId,
    },
  });
  return response.data;
};

export const useStartSignUp = () =>
  useMutation({
    onError: (error, variables) => {
      captureException(error, {
        tags: {
          operation: "postCustomerSignUp",
          errorType: error.name || "UnknownError",
        },
        extra: {
          variables: {
            transactionId: variables.transactionId,
          },
          apiEndpoint: "/auth/sign-up",
        },
        level: "error",
      });
    },
    mutationFn: ({
      personalNumber,
      transactionId,
    }: {
      personalNumber: string;
      transactionId: string;
    }) => startSignUp({ personalNumber, transactionId }),
  });
